import script from "./TaskReportTable.vue?vue&type=script&setup=true&lang=js"
export * from "./TaskReportTable.vue?vue&type=script&setup=true&lang=js"

import "./TaskReportTable.vue?vue&type=style&index=0&id=555c6751&lang=scss"

const __exports__ = script;

export default __exports__